import { render } from "./DISCWheelWedge.vue?vue&type=template&id=4231e996"
import script from "./DISCWheelWedge.vue?vue&type=script&lang=js"
export * from "./DISCWheelWedge.vue?vue&type=script&lang=js"
script.render = render

export default script